<template>
	<b-modal
		:visible="value"
		hide-footer
		ref="modal-view-resume"
		size="xl"
		:title="'Migración'"
		@hide="hidded"
	>
		
		<div class="container" v-if="modelInfo.id>0">
			<h4>[ID:{{modelInfo.id}}] {{modelInfo.name}}</h4>
			<b-row class="justify-content-center text-center" >
				<b-col cols="12">
					<b-alert show>
						A continuación se lista los lugares en donde se esta usando este tipo de servicio.
					</b-alert>
				</b-col>
			</b-row>
			<b-tabs no-fade pills card small vertical nav-class="nav-style">
				<b-tab title="Rides [service Type]" active>
					<AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-2"
					:filters="filtersForTsHasServiceType"
					:columns="modelColumns"
					resource="service-types/actions/resume">
					</AjaxTable>
				</b-tab>
				<b-tab title="Rides [supplier service Type]" >
					<AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-3"
					:filters="filtersForTsHasSupplierServiceType"
					:columns="modelColumns"
					resource="service-types/actions/resume">
					</AjaxTable>
				</b-tab>
				<b-tab title="Rates plan">
					<h2>Rate plans heredables:</h2>
					<AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-2"
					:filters="filtersForRatePlans"
					:columns="modelColumnsRatePlans"
					resource="service-types/actions/resume">
					</AjaxTable>

					<h2>Suppliers:</h2>
					<AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-2"
					:filters="filtersForRatePlansSupplier"
					:columns="modelColumnsRatePlansSupplier"
					resource="service-types/actions/resume">
					</AjaxTable>

					<h2>Resumen Suppliers:</h2>
					<AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-rp"
					:filters="filtersForRatePlansUsedBySupplier"
					:columns="modelColumnsSupplierList"
					resource="service-types/actions/resume">
					</AjaxTable>

					<h2>Canales:</h2>
					<AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-2"
					:filters="filtersForRatePlansSalesChannel"
					:columns="modelColumnsRatePlansSalesChannel"
					resource="service-types/actions/resume">
					</AjaxTable>
					<h2>Resumen Canales:</h2>
					<AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-rp"
					:filters="filtersForRatePlansUsedBySalesChannel"
					:columns="modelColumnsSupplierList"
					resource="service-types/actions/resume">
					</AjaxTable>

					

					
				</b-tab>

				<b-tab title="Promociones">
					<AjaxTable
					permission-show="changelog.show"
					id="promotions-index"
					:filters="filtersForPromotions"
					:columns="modelColumnsPromotions"
					resource="service-types/actions/resume">
					</AjaxTable>
				</b-tab>
				<b-tab title="Mapeos">
					<AjaxTable
					permission-show="changelog.show"
					id="mapping-index"
					:filters="filtersForMapping"
					:columns="modelColumnsMapping"
					resource="service-types/actions/resume">
					</AjaxTable>
				</b-tab>
				

			</b-tabs>
			
		</div>

		<hr>
		<section v-if="$hasPermission('serviceType.migrate')">
			<b-row class="justify-content-center" >
				<b-col cols="9">
					<b-alert show>
						Todos los transport services que tengan el servicio seleccionado en el <b>FROM</b> se cambiarán por el <b>To</b>
					</b-alert>
				</b-col>
			</b-row>
			<b-form-row class="justify-content-center">
				<b-overlay :show="loading" no-wrap></b-overlay>
				<b-form-group class="col-4" label="Service from">
					<b>[{{modelInfo.id}}]{{modelInfo.name}}</b>
				</b-form-group>
				<b-col class="col-1">
					<svg class="arrow" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M14 5l7 7m0 0l-7 7m7-7H3"
					/>
					</svg>
				</b-col>
				
				
				<b-form-group class="col-4" label="Service To">
					<multiselect
						v-model="toServiceId"
						:options="serviceTypeOpts"
						label="text"
						placeholder="Seleccione 1 opción"
					/>
				</b-form-group>
			</b-form-row>
			
		</section>	
		
	</b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import AjaxTable from "@/components/helpers/AjaxTable.vue";
export default {

	props: {
		value:Boolean
	},
	components: {
		Multiselect,AjaxTable
	},
	data() {
		const defaultModelInfo = {
			id: -1,
			code: "",
			name: "",
			serviceType: "private",
			maxPax: 1,
			maxSuitecases: 1,
			score: 5,
			status: "active",
			expediaIds: "",
			jayrideIds: "",
			category: "standardCar",
			description: "",
			suitecasesDescription: "",
			isShared: false
		};
		return {
			modelId:-1,
			modelInfo:{...defaultModelInfo},
			loading:false,
			fromServiceId: {value:-1,text:""},
			toServiceId: {value:-1,text:""},
			modelColumns:[
				{key:'reservationId',label:'ResId'},
				{key:'serviceNumber',label:'#Ride'},
				{key:'sales_channel.name',label:'Canal de venta'},
				{key:'supplier.name',label:'Proveedor'},
				{key:'pickupDatetime',label:'Service Date'},
				{key:'status',label:'Estado'},
			],
			modelColumnsRatePlansSalesChannel:[
				{key:'id',label:'id'},
				{key:'sales_channel.name',label:'Canal de venta'},
				{key:'zoned_area.name',label:'Zona de operacion'},
				{key:'startDate',label:'Start date'},
				{key:'endDate',label:'endDate'},
				{key:'status',label:'Status'},
			],
			modelColumnsRatePlansSupplier:[
				{key:'id',label:'id'},
				{key:'supplier.name',label:'Supplier'},
				{key:'zoned_area.name',label:'Zona de operacion'},
				{key:'startDate',label:'Start date'},
				{key:'endDate',label:'endDate'},
				{key:'status',label:'Status'},
			],
			modelColumnsRatePlans:[
				{key:'id',label:'id'},
				{key:'zoned_area.name',label:'Zona de operacion'},
				{key:'startDate',label:'Start date'},
				{key:'endDate',label:'endDate'},
				{key:'status',label:'Status'},
			],
			modelColumnsMapping:[
				{key:'id',label:'id'},
				{key:'name',label:'Name'},
				{key:'status',label:'Status'},
			],
			modelColumnsPromotions:[
				{key:'id',label:'Id promoción'},
				{key:'supplierName',label:'Supplier'},
				{key:'name',label:'Name'},
				{key:'bookingWindow',label:'Booking window'},
				{key:'travelWindow',label:'Travel window'},
				{key:'description',label:'Description'},
				
			],
			modelColumnsSupplierList:[
				{key:'id',label:'Id'},
				{key:'name',label:'Name'},			
			]
		};
	},
	computed: {
		serviceTypeOpts(){
			let aux = [];
			this.$root.auxVars.serviceTypesOpts.forEach(element => {
				let item      = {...element};
				item.text = "["+item.value+"] "+item.text;
				aux.push(item)
			});
			
			return aux ;
		},
		filters(){
			return {serviceTypeId:this.modelId}
		},

		filtersForTsHasServiceType(){
			return {...this.filters,...{resource:"tsHasServiceType"}}
		},
		filtersForTsHasSupplierServiceType(){
			return {...this.filters,...{resource:"tsHasSupplierServiceType"}}
		},
		filtersForRatePlans(){
			return {...this.filters,...{resource:"ratePlans"}}
		},
		filtersForRatePlansSupplier(){
			return {...this.filters,...{resource:"ratePlansSupplier"}}
		},
		filtersForRatePlansSalesChannel(){
			return {...this.filters,...{resource:"ratePlansSalesChannel"}}
		},
		filtersForMapping(){
			return {...this.filters,...{resource:"mapping"}}
		},
		filtersForPromotions(){
			return {...this.filters,...{resource:"promotions"}}
		},
		filtersForRatePlansUsedBySupplier(){
			return {...this.filters,...{resource:"ratePlansUsedBySupplier"}}
		},
		filtersForRatePlansUsedBySalesChannel(){
			return {...this.filters,...{resource:"ratePlansUsedBySalesChannel"}}
		},
		

	},
	methods: {
		fetchModel() {
			if (this.modelId > 0) {
				this.loading = true;
				this.$root.api
					.get(`/service-types/${this.modelId}`)
					.then(res => {
						this.modelInfo = { ...res.data };
						this.loading = false;
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.modelInfo = { ...this.defaultModelInfo };
				this.loading = false;
			}
		},
		loadModel(id) {
			this.modelId = id;
			this.$refs["modal-view-resume"].show();
			this.fetchModel();
		},
		hidded(){
			this.$emit("closed");
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['serviceTypesOpts']})
		
	}
};
</script>

<style></style>
